/**
 * Feature flag names - add new flags here for type safety
 * These should match the flag names configured in Unleash
 */
export enum FeatureFlag {
  // Game features
  GAME_CASES = 'game-cases',
  GAME_CASES_DAILYFREE = 'game-cases-dailyfree',
  GAME_ARCADE_WORDFRAG = 'game-arcade-wordfrag',
  GAME_ARCADE_PRICE_DUEL = 'price-duel',
  GAME_ARCADE_DEFUSE_ZONE = 'defuse-zone',
  GAME_GIVEAWAYS = 'game-giveaways',
  GAME_EVENTS = 'game-events',
  GAME_UPGRADE = 'game-upgrade',
  GAME_ARENA = 'game-arena',
  GAME_CONTRACTS = 'game-contracts',
  GAME_SKIN_CLASH = 'game-skin-clash',

  // Deposit methods
  DEPOSIT_CRYPTO = 'deposit-crypto',
  DEPOSIT_GIFTCARD = 'deposit-giftcard',
  DEPOSIT_GIFTCARD_PULSE = 'deposit-giftcard-pulse',
  DEPOSIT_GIFTCARD_KINGUIN = 'deposit-giftcard-kinguin',
  DEPOSIT_SKINS = 'deposit-skins',
  DEPOSIT_TOKENCODE = 'deposit-tokencode',
  DEPOSIT_STEAM_WALLET = 'deposit-steam-wallet',
  DEPOSIT_VIP_REDEPOSIT = 'deposit-vip-redeposit',
  DEPOSIT_PAYOP = 'deposit-payop',

  // Modals
  MODAL_PROMO_ANNOUNCEMENT = 'promo-popup',
}

/**
 * Unleash context for targeting specific users/sessions
 * Note: properties values must be strings (Unleash requirement)
 */
export interface UnleashContext {
  userId?: string
  sessionId?: string
  remoteAddress?: string
  properties?: Record<string, string>
}

/**
 * Configuration for Unleash client
 */
export interface UnleashConfig {
  url: string
  clientKey: string
  appName: string
  environment?: string
  refreshInterval?: number
}

/**
 * Feature flag state
 */
export interface FeatureFlagsState {
  initialized: boolean
  loading: boolean
  error: string | null
  flags: Record<string, boolean>
}
